package com.hyperether.goodjob.scenes.dashboard

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.em
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.boxMargin
import com.hyperether.goodjob.log
import com.hyperether.goodjob.map.MapComponent
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.repository.remote.model.LatLng
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.check_soon
import com.hyperether.goodjob.resources.dashboard
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.lets_get_to_work
import com.hyperether.goodjob.resources.location
import com.hyperether.goodjob.resources.locations_agenda
import com.hyperether.goodjob.resources.locations_agenda_text
import com.hyperether.goodjob.resources.no_tasks_assigned
import com.hyperether.goodjob.resources.no_tasks_created
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.time
import com.hyperether.goodjob.resources.title
import com.hyperether.goodjob.resources.today_schedule
import com.hyperether.goodjob.resources.upcoming_jobs
import com.hyperether.goodjob.resources.user
import com.hyperether.goodjob.scenes.components.WebFilterButton
import com.hyperether.goodjob.scenes.components.WebSearchField
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.jobs.components.JobsListWebDashboard
import com.hyperether.goodjob.scenes.map.MapViewModel
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.SubtitleColor
import com.hyperether.goodjob.util.FilterDialogStateManager
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.goodjob.webDetailsTitle
import com.hyperether.planner.ui.DashboardDayPlanner
import com.hyperether.planner.ui.SchedulerDayPlanner
import com.hyperether.resources.stringResource

@Composable
fun DashboardScreenWeb(
    dashboardViewModel: DashboardViewModel,
    mapViewModel: MapViewModel,
    selectedJobs: MutableList<Job>,
    isInEditMode: Boolean,
    navHostController: NavHostController,
    screenWidth: Float = 0f,
    screenHeight: Float = 0f,
    isMobileView: Boolean
) {
    val webHeaderSearchAddHeight = 136.toScaleDp()
    val paddingHeight = 30.toScaleDp()

    val jobs = dashboardViewModel.filteredJobs.toList()
    val events = dashboardViewModel.listOfPlans.flatMap { it.events }
    log.d("Scheduler DashboardScreenWebView recompose") { "events size: ${events.size} jobs size: ${jobs.size}" }
    val currentPosition = remember { mutableStateOf<LatLng?>(null) }
    val jobSearchText = remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        FilterDialogStateManager.setDialogShowing(false)
        dashboardViewModel.init()
        mapViewModel.init()
    }

    LaunchedEffect(dashboardViewModel.filteredJobs.toList()) {
        mapViewModel.updateMapMarkers(dashboardViewModel.filteredJobs)
        dashboardViewModel.parseSchedule()
        val events = dashboardViewModel.listOfPlans.flatMap { it.events }
        log.d("Scheduler DashboardScreenWebView parseSchedule") { "events size: ${events.size}" }
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
    ) {
        WebViewHeader(
            isBackAvailable = false,
            title = stringResource(Res.string.dashboard),
            isImportAndAddVisible = !dashboardViewModel.isEmployee(),
            navHostController = navHostController,
            isLanguageVisible = true
        )

//        Spacer(modifier = Modifier.height(15.toScaleDp()))
        // Scheduler and Map Section
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .padding(vertical = 15.toScaleDp(), horizontal = 75.toScaleDp())
        ) {
            // Scheduler
            Column(
                modifier = Modifier
                    .weight(0.6f)
                    .fillMaxHeight()
                    .background(Color.White, shape = boxCornerShape())
                    .border(
                        width = 1.toScaleDp(),
                        shape = boxCornerShape(),
                        color = BorderColor
                    )
                    .padding(boxMargin())
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    Text(
                        stringResource(Res.string.today_schedule),
                        fontSize = 16.toScaleSp(),
                        fontWeight = FontWeight.W700,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Text(
                        stringResource(Res.string.lets_get_to_work), fontSize = 16.toScaleSp(),
                        fontWeight = FontWeight.W400,
                        color = SubtitleColor,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
//                key(dashboardViewModel.listOfPlans) {
                if (!dashboardViewModel.isEmployee()) {
                    SchedulerDayPlanner(
                        listOfPlans = dashboardViewModel.listOfPlans,
                        startHour = dashboardViewModel.listOfPlans.flatMap { it.events }
                            .minOfOrNull { it.from.hour } ?: 8,
                        onEventClicked = { event ->
                            val selectedJob =
                                dashboardViewModel.jobList.firstOrNull { it.id == event.jobId }
                            dashboardViewModel.selectedJobDashboard.value = selectedJob
                            selectedJob?.let { dashboardViewModel.updateSite(it) }
                            dashboardViewModel.jobClicked.value = true
                        },
                        namesIconsShown = true,
                        screenHeight = (screenHeight - webHeaderSearchAddHeight.value - paddingHeight.value) / 2 - 20.toScaleDp().value,
                        screenWidth = 0f,
                        isMobile = false
                    )
                } else {
                    DashboardDayPlanner(
                        onEventClicked = { event ->
                            val selectedJob =
                                dashboardViewModel.jobList.firstOrNull { it.id == event.jobId }
                            dashboardViewModel.selectedJobDashboard.value = selectedJob
                            selectedJob?.let { dashboardViewModel.updateSite(it) }
                            dashboardViewModel.jobClicked.value = true
                        },
                        listOfPlans = dashboardViewModel.listOfPlans,
                        screenHeight = 0f,
                        screenWidth = screenWidth,
                        isMobileView = isMobileView,
                        startHour = dashboardViewModel.listOfPlans.flatMap { it.events }
                            .minOfOrNull { it.from.hour } ?: 8)
                }
//                }
            }
            Spacer(modifier = Modifier.width(15.toScaleDp()))
            // Map
            Box(
                modifier = Modifier
                    .weight(0.4f)
                    .fillMaxHeight()
                    .background(Color.White, shape = boxCornerShape())
                    .border(
                        width = 1.toScaleDp(),
                        shape = boxCornerShape(),
                        color = BorderColor
                    )
            ) {
                Column {
                    Column(
                        modifier = Modifier.padding(boxMargin())
                    ) {
                        Text(
                            "${dashboardViewModel.jobList.size} ${stringResource(Res.string.locations_agenda)}",
                            style = MaterialTheme.typography.titleLarge,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            fontSize = 24.toScaleSp(),
                            fontWeight = FontWeight.W700,
                        )
                        Spacer(modifier = Modifier.height(8.toScaleDp()))
                        Text(
                            stringResource(Res.string.locations_agenda_text),
                            maxLines = 1,
                            fontSize = 16.toScaleSp(),
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                     mapViewModel.markers.firstOrNull()?.let {
                         currentPosition.value = LatLng(it.lat, it.lng)
                     }
                    MapComponent(
                        markers = mapViewModel.markers.toList(),
                        currentPosition = currentPosition,
                        showMapWeb = mutableStateOf(true)
                    )
                }
            }
        }

        // Upcoming Tasks Section
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .padding(start = 75.toScaleDp(), end = 75.toScaleDp(), bottom = 15.toScaleDp())
        ) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.White, shape = boxCornerShape())
                    .border(
                        width = 1.toScaleDp(),
                        shape = boxCornerShape(),
                        color = BorderColor
                    )
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(webDetailsTitle())
                        .drawBehind {
                            val strokeWidth = Dp(1f).toPx()
                            drawLine(
                                color = BorderColor,
                                start = Offset(0f, size.height - strokeWidth / 2),
                                end = Offset(size.width, size.height - strokeWidth / 2),
                                strokeWidth = strokeWidth
                            )
                        }
                        .padding(boxMargin()),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(
                        modifier = Modifier.weight(2f),
                    ) {
                        androidx.compose.material.Text(
                            text = stringResource(Res.string.upcoming_jobs),
                            fontSize = 24.toScaleSp(),
                            fontWeight = FontWeight.W700,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        if (dashboardViewModel.selectedJobs.isNotEmpty()) {
                            androidx.compose.material.Text(
                                text = stringResource(Res.string.delete).lowercase()
                                    .replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                color = Color.Red,
                                fontSize = 16.toScaleSp(),
                                modifier = Modifier
                                    .padding(top = 12.toScaleDp())
                                    .clickableWithPointer {
                                        dashboardViewModel.showAreYouSurePopUpDeleteJob.value = true
                                    }
                            )
                        }
                    }
                    WebSearchField(
                        text = jobSearchText.value,
                        onTextChange = {
                            jobSearchText.value = it
                        }
                    )
                    Spacer(modifier = Modifier.width(16.toScaleDp()))

                    if (dashboardViewModel.jobList.isNotEmpty()) {
                        WebFilterButton(
                            onClick = {
                                FilterDialogStateManager.setDialogShowing(true)
                            }
                        )
                        Spacer(modifier = Modifier.width(16.toScaleDp()))
                    }
                }
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color(0xfffafafa))
                        .padding(horizontal = 22.toScaleDp())
                        .requiredHeight(38.toScaleDp()),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    androidx.compose.material.Text(
                        text = stringResource(Res.string.title),
                        fontWeight = FontWeight.W700,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                        modifier = Modifier.weight(0.9f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    androidx.compose.material.Text(
                        text = stringResource(Res.string.site),
                        fontWeight = FontWeight.W700,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                        modifier = Modifier.weight(1.1f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    androidx.compose.material.Text(
                        text = stringResource(Res.string.location),
                        fontWeight = FontWeight.W700,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                        modifier = Modifier.weight(1.6f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    androidx.compose.material.Text(
                        text = stringResource(Res.string.time),
                        fontWeight = FontWeight.W700,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                        modifier = Modifier.weight(0.6f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    androidx.compose.material.Text(
                        text = stringResource(Res.string.user),
                        fontWeight = FontWeight.W700,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                        modifier = Modifier.weight(0.5f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    androidx.compose.material.Text(
                        text = stringResource(Res.string.status),
                        fontWeight = FontWeight.W700,
                        textAlign = TextAlign.Center,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                        modifier = Modifier.weight(0.5f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
                if (dashboardViewModel.isEmployee() && dashboardViewModel.jobList.size == 0) {
                    Text(
                        text = stringResource(Res.string.no_tasks_created),
                        color = Color.Black,
                        fontSize = 24.toScaleSp(),
                        textAlign = TextAlign.Center,
                        fontWeight = FontWeight.Bold,
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 60.toScaleDp(),
                                start = 16.toScaleDp(),
                                end = 16.toScaleDp()
                            )
                    )
                    Text(
                        text = stringResource(Res.string.check_soon),
                        color = Color.Gray,
                        textAlign = TextAlign.Center,
                        fontSize = 16.toScaleSp(),
                        modifier = Modifier.fillMaxWidth().padding(
                            top = 20.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                    )
                } else if (!dashboardViewModel.isEmployee() && dashboardViewModel.jobList.size == 0) {
                    Text(
                        text = stringResource(Res.string.no_tasks_created),
                        color = Color.Black,
                        fontSize = 24.toScaleSp(),
                        textAlign = TextAlign.Center,
                        fontWeight = FontWeight.Bold,
                        modifier = Modifier.fillMaxWidth()
                            .padding(
                                top = 60.toScaleDp(),
                                start = 16.toScaleDp(),
                                end = 16.toScaleDp()
                            )
                    )
                    Text(
                        text = stringResource(Res.string.no_tasks_assigned),
                        color = Color.Gray,
                        textAlign = TextAlign.Center,
                        fontSize = 16.toScaleSp(),
                        modifier = Modifier.fillMaxWidth().padding(
                            top = 20.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                    )
                } else {
                    JobsListWebDashboard(
                        sites = dashboardViewModel.sitesMap,
                        jobs = dashboardViewModel.searchAndSortJobs(jobSearchText.value),
                        selectedJobs = selectedJobs,
                        isInEditMode = isInEditMode,
                        navHostController = navHostController
                    )
                }
            }
        }
    }
}